<template>
  <div class="box">
    <back @change="back"/>
    <p class="title">个人信息披露知情同意</p>
    <div class="content">
      <p>
        本文件旨在向您告知有关拜耳医药保健有限公司（“拜耳”）在收集、使用和保护个人信息方面的政策，并且，一旦签 署，您将允许拜耳使用您的个 人信息。请仔细阅读本知情同意，并根据您的需要询问任何事顶。
      </p>
      <p style="font-weight: bold">
        收集个人信息：
      </p>
      <p style="text-indent: 20px;">
        您已被告知，并且您已同意拜耳将收集和使用您所提供的如下个人信息，包括：（1）您的姓名，（2）您工作所在的医疗机构， （3）您工作所在的科室，（4）您的职称。拜耳的员工将拜访您，并收集前述个人信息。（5）您的联系方式（电子邮箱、联系电话，微信号和头像），（6）拜访电话的录音（保存2年）。 我们不会主动收集您的联系方式，只有当您希望拜耳主动联系您时，您可以留下您的联系方式。
      </p>
      <p style="font-weight: bold">
        使用个人信息：
      </p>
      <p style="text-indent: 20px;">
        基于您愿意与拜耳开展合作，以接受拜耳提供的科学信息和产品信息，并参加相关意见调查，拜耳将为以下目的使用您的 个人信息：（1）拜耳与您之间的学术交流；（2）邀请您参加学术会议；（3）邀请您参加意见调查；（4）发送文件或材料。（5）提高我们的服务质量。
      </p>
      <p style="font-weight: bold">
        向第三方披露个人信息：
      </p>
      <p>
        拜耳将向国内或国外的拜耳关联方或拜耳所委托的第三方披露您的个人信息，并且该等关联方或第三方将为本知情同意中所规定之目的使用您的个人信息。我们仅在必要时才分享信息且分享仅限于本声明所示的目的。如果改变了收集和使用目的，则需要另行获得您的同意。
      </p>
      <p style="font-weight: bold">
        个人信息保存：
      </p>
      <p>
        我们仅在为实现本知情同意书下目的所必要的时间内保留您的个人数据。如您对个人信息保存时间有异议，您可以在任何时候，通过以下联系方式撤回您的同意或限制我们使用您的个人信息。
      </p>
      <p style="font-weight: bold">
        个人信息保护：
      </p>
      <p style="text-indent: 20px;">
        拜耳已制定了相关政策并釆取了相关安全措施，以保护您的个人信息免受未经授权的访问、篡改、泄露、毀损或丢失。 拜耳将与接收您个人信息的任何授权第三方订立书面合同，确保该第三方承担有关釆取安全措施保护您个人信息的合同义务。您有权在 任何时间通过拨打拜耳热线电话4008100360，撤销您所作出的有关拜耳使用您个人信息的同意，或要求拜耳停止向您发送任何信息或材料。
      </p>
      <p style="font-weight: bold">
        联系方式：
      </p>
      <p style="text-indent: 20px;">
        如果您在将来任何时间针对您的个人信息有任何问题或投诉，也请拨打拜耳热线电话4008100360，或者发送邮件到DP.China@bayer.com。我们将在15个工作日内予以相应。
      </p>
      <p style="font-weight: bold">医疗卫生专业人士同意声明</p>
      <p style="text-indent: 20px;">
        本人已阅读本知情同意中的信息。本人己获得机会询问相关问题。本人同意提供本人的个人信息，以供拜耳根据本知情同意使用， 并且同意拜耳可以根据本知情同意向经授权的第三方披露本人的个人信息，本人声明和保证，本人在向拜耳提供个人信息前，已获得本人所在单 位的相关批准或许可 (如需要），并且本人提供个人信息的行为不会违反适用的法律法规以及本人所在单位的规章制度。
      </p>
      <p style="text-indent: 20px;">
        本文件旨在向您告知有关拜耳医药保健有限公司（“拜耳”）在收集、使用和保护个人信息方面的政策，并且，一旦签 署，您将允许拜耳使用您的个 人信息。请仔细阅读本知情同意，并根据您的需要询问任何事顶。
      </p>
    </div>
  </div>
</template>

<script>
import Back from "@/components/back/Back";
export default {
  name: "Agreement",
  components: {Back},
  methods: {
    back() {
      this.$router.back()
    }
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style lang="scss" scoped>
.content {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  padding-bottom: 180px;
  p {
    color: #333333;
    font-size: 28px;
    text-align: left;
    line-height: 42px;
  }
}
.box {
  background: #f5f5f5;
}
.title {
  font-size: 40px;
  color: #00476C;
  margin: 30px 0;
}
</style>
